<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="导出"
    :visible.sync="dialogVisible"
    width="506px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-row>
        <el-col class="panel" :span="12">
          <div class="btn" @click="exportOrigin">导出{{ type | formatOrigin }}</div>
        </el-col>
        <el-col class="panel" :span="12">
          <div class="btn" @click="exportProfit">导出{{ type | formatProfit }}</div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-col class="panel" :span="12">
          <div class="btn" @click="exportPayble">导出{{ type | formatPayble }}</div>
        </el-col>
        <el-col class="panel" :span="12" v-if="type === 0">
          <div class="btn" @click="exportSummary">导出{{ type | formatSummary }}</div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
// import {
//   grossProfitExportClePicOrigin,
//   grossProfitExportClePicProfit,
//   grossProfitExportClePicPayble
// } from '@/api/fee'
import { derive } from '@/utils/common'
export default {
  components: {},
  filters: {
    formatOrigin(v) {
      const obj = {
        0: '清提原始表',
        1: '派送原始表',
        2: '导出其他业务原始表'
      }
      return obj[v]
    },
    formatProfit(v) {
      const obj = {
        0: '清提利润表',
        1: '代理利润表',
        2: '导出其他业务利润表'
      }
      return obj[v]
    },
    formatPayble(v) {
      const obj = {
        0: '清提应付表',
        1: '客户利润表',
        2: '导出其他业务应付表'
      }
      return obj[v]
    },
    formatSummary(v) {
      const obj = {
        0: '清提汇总表',
      }
      return obj[v]
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: function() {
        return {}
      }
    },
    type: {
      type: Number,
      default: 0 // 0 清提 1 派送
    }
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {},
  methods: {
    cancel() {
      this.$emit('cancel')
    },
   async exportOrigin() {
      this.loading = true
      if (!this.type) {
       await derive('Analysis/grossProfitExportClePicOrigin', 'post', this.filter)
      } else if (this.type === 1) {
        await derive('Analysis/grossProfitExportDelivery', 'post', this.filter)
      } else {
        await derive('Analysis/grossProfitExportOtherService', 'post', this.filter)
      }
      this.loading = false
    },
    async exportProfit() {
      this.loading = true
      if (!this.type) {
        await derive('Analysis/grossProfitExportClePicProfit', 'post', this.filter)
      } else if (this.type === 1) {
        await derive('Analysis/grossProfitExportSupplierDelivery', 'post', this.filter)
      } else {
        await derive('Analysis/grossProfitExportSupplierOtherService', 'post', this.filter)
      }
      this.loading = false
    },
    async exportPayble() {
      this.loading = true
      if (!this.type) {
        await derive('Analysis/grossProfitExportClePicPayble', 'post', this.filter)
      } else if (this.type === 1) {
        await derive('Analysis/grossProfitExportCompanyDelivery', 'post', this.filter)
      } else {
        await derive('Analysis/grossProfitExportClientOtherService', 'post', this.filter)
      }
      this.loading = false
    },
    async exportSummary() {
      this.loading = true
      if (this.type === 0) {
        await derive('Analysis/grossProfitExportClePicSummary', 'post', this.filter)
      }
      this.loading = false
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  .panel {
    display: flex;
    justify-content: center;
  }
  .btn {
    width: 180px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
